// import { Container } from 'react-bootstrap';
import '../../css/Content.css';
import 'bootstrap/dist/css/bootstrap.min.css'

export const Page2 = () => {




  return (
    <>      
      <section>   

      <div className='container'>

        <div style={{ paddinBottom: "80px"}}>  

          <div style={{height: '85vh', display: 'flex', alignItems: 'center', color: '#ffffff'}}>
            <div>
              <p>
                Mudanças fazem parte da rotina das operações industriais, seja para melhorar processos, corrigir desvios ou atender a novas demandas. Mas você já refletiu que até alterações simples podem gerar impactos significativos quando não são avaliadas e controladas?
              </p>
              <p>
                É nesse ponto que surge a necessidade de um método estruturado para gerenciar mudanças de forma segura e consistente.
              </p>
              <p>
               E por que esse cuidado é tão importante? A resposta está nos acidentes industriais do passado, muitos deles causados por mudanças feitas sem controle, que evidenciaram riscos graves e impulsionaram a criação de práticas voltadas à proteção das pessoas, do meio ambiente e das instalações.
              </p>                   
            </div>
          </div>         

        </div>
        
      </div>

      </section>
    </>
  );
};

export default Page2;